/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "566")
  

// 接口文档

  
    
export interface IAPI77042ReqAppInstanceObjComponentInstanceListItemBlockListItemPropertyListItemOptionListItem {
  
  /** 选项名称 */
  key?: string;
  
  /** 选项值 */
  value?: string;
  
};
    
  
    
export interface IAPI77042ReqAppInstanceObjComponentInstanceListItemBlockListItemPropertyListItem {
  
  /** 属性编码 */
  propertyCode?: string;
  
  /** 属性名称 */
  propertyName?: string;
  
  /** 属性类型 */
  propertyType?: string;
  
  /** 属性key */
  propertyKey?: string;
  
  /** 属性值 */
  propertyValue?: string;
  
  /** 选中值 */
  selectValue?: string;
  
  /** 选项范围 ,OptionReq */
  optionList?: IAPI77042ReqAppInstanceObjComponentInstanceListItemBlockListItemPropertyListItemOptionListItem[];
  
};
    
  
    
export interface IAPI77042ReqAppInstanceObjComponentInstanceListItemBlockListItem {
  
  /** 区块名称 */
  blockName?: string;
  
  /** 区块类型 */
  blockType?: string;
  
  /** 最少数量 */
  leastNum?: number;
  
  /** 最多数量 */
  mostNum?: number;
  
  /** 属性列表 ,AppPropertyReq */
  propertyList?: IAPI77042ReqAppInstanceObjComponentInstanceListItemBlockListItemPropertyListItem[];
  
};
    
  
    
export interface IAPI77042ReqAppInstanceObjComponentInstanceListItem {
  
  /** 组件模板编码 */
  componentCode?: string;
  
  /** 坐标 */
  coordinate?: string;
  
  /** 组件模板名称 */
  componentName?: string;
  
  /** 组件分类 */
  componentClassify?: string;
  
  /** 组件类型 */
  componentType?: string;
  
  /** 区块列表 ,AppBlockReq */
  blockList?: IAPI77042ReqAppInstanceObjComponentInstanceListItemBlockListItem[];
  
};
    
  
    
export interface IAPI77042ReqAppInstanceObjPropertyLineListItem {
  
  /** 输出属性编码 */
  outPropertyCode?: string;
  
  /** 输入属性编码 */
  inPropertyCode?: string;
  
};
    
  
    
export interface IAPI77042ReqAppInstanceObj {
  
  /** 应用实例编码 */
  appInstanceCode?: string;
  
  /** 应用版本 */
  appVersion?: string;
  
  /** 实例状态 */
  appStatus?: number;
  
  /** 组件实例列表 ,AppComponentReq */
  componentInstanceList?: IAPI77042ReqAppInstanceObjComponentInstanceListItem[];
  
  /** 属性连线列表 ,AppPropertyLineReq */
  propertyLineList?: IAPI77042ReqAppInstanceObjPropertyLineListItem[];
  
};
    
  



export interface API77042Req {
  
  /** 应用编码 */
  appCode?: string;
  /** 应用名称 */
  appName?: string;
  /** 应用描述 */
  appDesc?: string;
  /** 是否多轮 */
  multiFlag?: number;
  /** 应用实例信息 ,AppInstanceCmdReq */
  appInstance?: IAPI77042ReqAppInstanceObj;
};



export type API77042Res = {};


// 接口函数 77042 保存应用实例

export interface IUsePostAPI77042Return {
  /** 保存应用实例: 接口请求状态 */
  isAPI77042Loading: boolean;
  /** 保存应用实例: 接口请求返回数据 */
  dataAPI77042: API77042Res;
  /**  保存应用实例: 接口数据请求方法 */
  fetchAPI77042Data: (inputs: API77042Req, config?: YWRequestConfig) => Promise<API77042Res>;
  /** 保存应用实例: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI77042 = ():IUsePostAPI77042Return => {
  let isMount = true;
  const [isAPI77042Loading, setIsAPI77042Loading] = useState(false);
  const [dataAPI77042, setDataAPI77042] = useState<API77042Res>({} as API77042Res);
  const requestUrl = `${basePath}/yoaichat-admin/app/instance/save`;

  const fetchAPI77042Data = async (inputs: API77042Req, config?: YWRequestConfig): Promise<API77042Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API77042Req>) || {}) as API77042Req;
    
  
    if ( isMount ) {
      setIsAPI77042Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API77042Res>(`${basePath}/yoaichat-admin/app/instance/save`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI77042(res || {} as API77042Res);
        setIsAPI77042Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI77042Loading(false);
      }
      return false as unknown as API77042Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI77042Loading,
    dataAPI77042,
    fetchAPI77042Data,
    requestUrl,
  }
}

